export default __webpack_public_path__ + "81ceca0746f38641c7e4dbd95328e20d.jpg";